export { default } from './SimpleProductsList';
